
export const products = [
  {
    id: 1,
    name: 'Classic Walnut Bowl',
    description: 'A timeless piece crafted from rich walnut wood, featuring deep chocolate tones and elegant grain patterns. Perfect for serving salads or displaying fruit.',
    price: 145,
    image: 'https://public.readdy.ai/ai/img_res/c13d2a9134b1d74e58ff37218264bc43.jpg',
    featured: true
  },
  {
    id: 2,
    name: 'Maple Serving Bowl',
    description: 'Light and beautiful maple wood bowl with subtle grain variations. Its warm honey tones bring brightness to any table setting.',
    price: 125,
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20maple%20wooden%20bowl%20with%20light%20honey%20color%20and%20delicate%20grain%20patterns%2C%20smooth%20finish%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20artisan%20craftsmanship&width=600&height=800&seq=product-maple-001&orientation=portrait',
    featured: false
  },
  {
    id: 3,
    name: 'Cherry Wood Display Bowl',
    description: 'Stunning cherry wood bowl with reddish-brown hues that deepen with age. A beautiful centerpiece for any room.',
    price: 165,
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20cherry%20wood%20bowl%20with%20reddish-brown%20color%20and%20beautiful%20grain%2C%20polished%20finish%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20elegant%20design&width=600&height=800&seq=product-cherry-001&orientation=portrait',
    featured: true
  },
  {
    id: 4,
    name: 'Oak Rustic Bowl',
    description: 'Robust oak bowl with prominent grain patterns and natural character. Perfect for those who appreciate rustic elegance.',
    price: 135,
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20oak%20wooden%20bowl%20with%20prominent%20grain%20patterns%20and%20natural%20wood%20character%2C%20medium%20brown%20color%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting&width=600&height=800&seq=product-oak-001&orientation=portrait',
    featured: false
  },
  {
    id: 5,
    name: 'Ash Wood Salad Bowl',
    description: 'Light-colored ash wood bowl with distinctive grain patterns. Ideal for everyday use and special occasions alike.',
    price: 115,
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20ash%20wood%20bowl%20with%20light%20color%20and%20distinctive%20grain%20patterns%2C%20smooth%20finish%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20modern%20design&width=600&height=800&seq=product-ash-001&orientation=portrait',
    featured: false
  },
  {
    id: 6,
    name: 'Mixed Wood Artisan Bowl',
    description: 'Unique bowl featuring multiple wood types in a stunning segmented design. Each piece is truly one-of-a-kind.',
    price: 195,
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20segmented%20wooden%20bowl%20with%20multiple%20wood%20types%20creating%20beautiful%20pattern%2C%20various%20natural%20wood%20tones%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20artistic%20design&width=600&height=800&seq=product-mixed-001&orientation=portrait',
    featured: true
  }
];
